import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { useAskAIContext } from '@/context/AskAiContext';
import PromptMenu from '../PromptMenu';
import UploadFileButton from '../UploadFileButton';

const FooterActions = () => {
	const { isBusy, session, draft, handleSend } = useAskAIContext();
	const sessionId = session?.sessionId ?? session?.id;
	const theme = useTheme();

	// Hide UploadFileButton for now until Folio AI has been adapted to use uploaded files correctly
	return (
		<Box
			sx={{
				px: 2.25,
				py: 1.75,
				borderTop: `1px solid ${theme.palette.divider}`,
				backgroundColor: alpha(theme.palette.background.paper, 0.72),
				display: 'flex',
				alignItems: 'center',
				gap: 1,
			}}
		>
			{/* <UploadFileButton /> */}
			<PromptMenu />
			<Box sx={{ flex: 1 }} />
			<Button
				variant='contained'
				onClick={() => handleSend()}
				disabled={!draft.trim() || !sessionId || isBusy || Boolean(session?.disabledReason)}
				endIcon={<SendRoundedIcon />}
				sx={{
					textTransform: 'none',
				}}
			>
				Send
			</Button>
		</Box>
	);
};

export default FooterActions;
